export default "__VITE_ASSET__BKA_jenv__"